import { render, staticRenderFns } from "./PhoneViewer.vue?vue&type=template&id=b3c261ce&"
import script from "./PhoneViewer.vue?vue&type=script&lang=js&"
export * from "./PhoneViewer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports